<template>
	<v-card elevation="0">
		<v-card-title class="mx-1" elevation="0">
			<v-btn
				v-show="selectedRequestGroup"
				icon
				@click="onRollbackSelection()"
			>
				<v-icon>mdi-chevron-left</v-icon>
			</v-btn>
			<v-spacer></v-spacer>
			<div
				class="text-mbf-color-4 font-bold text-base text-uppercase"
				style="font-size: 16px !important"
			>
				{{ getTitleDialog() }}
			</div>
			<v-spacer></v-spacer>
			<v-btn icon @click="close">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-dialog v-model="dialog.processRepeat" width="70vw">
			<EditProcessRepeat
				v-if="dialog.processRepeat"
				:idRequestGroup="selectedRequestGroup.id"
				:requestData="m_requestDataDto"
				:idRequestType="selectedRequest.id"
				:createdPyc="true"
				:editedItem="processRepeat"
				@close="dialog.processRepeat = false"
				@save="onSaveProcessRepeat"
			></EditProcessRepeat>
		</v-dialog>
		<v-card-text>
			<vue-perfect-scrollbar class="h-[70vh] px-3">
				<v-row v-if="getCurrentCreateProgress() === 'step-1'">
					<v-col cols="12" v-if="!selectedRequestGroup">
						<div>
							<v-text-field
								v-if="!selectedRequestGroup"
								v-model="search_request_group"
								hide-details
								:color="customColors['mbf-color-3']"
								background-color="rgba(247, 249, 254, 1)"
								single-line
								maxLength="255"
								@keyup="findRequestGroup()"
								loading
							>
								<template v-slot:label>
									<v-icon size="18" class="mr-1">
										mdi-magnify
									</v-icon>
									<span class="text-xs"
										>Tìm kiếm nhóm yêu cầu</span
									>
								</template>
								<template v-slot:progress>
									<v-progress-linear
										:color="customColors['mbf-color-3']"
										absolute
										height="1"
									></v-progress-linear>
								</template>
							</v-text-field>
						</div>
					</v-col>

					<div v-if="noResult" class="text-center mx-auto mt-[300px]">
						{{ $t("message.no_data") }}
					</div>

					<div
						v-for="(item, index) in requestGroups"
						:key="index"
						v-show="
							!selectedRequestGroup ||
							(selectedRequestGroup &&
								selectedRequestGroup.id === item.id)
						"
						class="w-full px-4"
					>
						<div
							class="
								flex
								items-center
								justify-between
								requestGroupHover
								mt-3
							"
						>
							<div
								class="
									flex
									gap-4
									items-center
									cursor-pointer
									pa-3
								"
								@click="selectRequestGroup(item)"
							>
								<div class="iconNhomYc">
									<GroupRequestIcon />
								</div>
								<div class="flex flex-col">
									<span
										class="
											text-base
											font-bold
											text-mbf-color-4
										"
									>
										{{ item.requestGroupName }}
									</span>
									<span
										class="
											text-opacity-90
											text-xs
											text-mbf-color-4
										"
									>
										{{ item.description }}
									</span>
									<div
										class="
											flex
											items-center
											justify-between
										"
										v-if="selectedRequest"
									>
										<span
											class="
												text-base
												font-bold
												text-mbf-color-4
											"
											>{{
												selectedRequest.requestName
											}}</span
										>
										<span
											class="
												text-xs
												text-opacity-90
												text-mbf-color-4
											"
											>{{
												selectedRequest.description
											}}</span
										>
										<!--										<v-btn-->
										<!--											v-if="selectedRequest"-->
										<!--											elevation="0"-->
										<!--											class="rounded-pill left-9"-->
										<!--											color="red darken-1"-->
										<!--											icon-->
										<!--											@click="-->
										<!--												deleteRequestTypeSelected(-->
										<!--													item,-->
										<!--													index,-->
										<!--												)-->
										<!--											"-->
										<!--										>-->
										<!--											<v-icon>mdi-close-circle</v-icon>-->
										<!--										</v-btn>-->
									</div>
								</div>
							</div>
							<!--							<div>-->
							<!--								<v-btn-->
							<!--									v-if="selectedRequestGroup"-->
							<!--									elevation="0"-->
							<!--									class="rounded-pill"-->
							<!--									color="red darken-1"-->
							<!--									icon-->
							<!--									@click="-->
							<!--										deleteRequestGroupSelected(item, index)-->
							<!--									"-->
							<!--								>-->
							<!--									<v-icon>mdi-close-circle</v-icon>-->
							<!--								</v-btn>-->
							<!--							</div>-->
						</div>
					</div>
				</v-row>
				<v-row v-if="getCurrentCreateProgress() === 'step-2'">
					<v-col cols="12">
						<div
							class="
								flex
								items-center
								justify-between
								requestGroupHover
								mt-3
							"
						>
							<div
								class="
									flex
									gap-4
									items-center
									cursor-pointer
									pa-3
								"
							>
								<div class="iconNhomYc">
									<GroupRequestIcon />
								</div>
								<div
									class="flex flex-col"
									v-if="selectedRequestGroup"
								>
									<span
										class="
											text-base
											font-bold
											text-mbf-color-4
										"
										>{{
											selectedRequestGroup.requestGroupName
										}}</span
									>
									<span
										class="
											text-xs
											text-opacity-90
											text-mbf-color-4
										"
										>{{ selectedRequestGroup.description }}
									</span>
								</div>
							</div>
						</div>
					</v-col>
					<v-col cols="12" class="mb-[-0.5rem] pt-0">
						<div>
							<v-text-field
								v-if="!selectedRequest"
								v-model="search_request_type"
								hide-details
								:color="customColors['mbf-color-3']"
								maxLength="255"
								background-color="rgba(247, 249, 254, 1)"
								single-line
								@keyup="findRequestType()"
								loading
								class="pt-0"
							>
								<template v-slot:label>
									<v-icon size="18" class="mr-1">
										mdi-magnify
									</v-icon>
									<span class="text-xs"
										>Tìm kiếm loại yêu cầu</span
									>
								</template>
								<template v-slot:progress>
									<v-progress-linear
										:color="customColors['mbf-color-3']"
										absolute
										height="1"
									></v-progress-linear>
								</template>
							</v-text-field>
						</div>
					</v-col>
					<div
						v-if="noRequestResult"
						class="text-center mx-auto mt-[300px]"
					>
						{{ $t("message.no_data") }}
					</div>
					<div
						v-for="(item, index) in requestTypes"
						:key="index"
						v-show="
							!selectedRequest ||
							(selectedRequest && selectedRequest.id === item.id)
						"
						class="w-full px-4"
					>
						<div
							class="
								flex
								items-center
								justify-between
								requestTypeHover
								mt-3
							"
						>
							<div
								class="
									flex
									gap-4
									items-center
									cursor-pointer
									pa-3
								"
								@click="selectRequestType(item)"
							>
								<div class="iconLoaiYc">
									<RequestIcon />
								</div>
								<div class="flex flex-col">
									<span
										class="
											text-base
											font-bold
											text-mbf-color-4
										"
										>{{ item.requestName }}</span
									>
									<span
										class="
											text-opacity-90
											text-xs
											text-mbf-color-4
										"
										>{{ item.description }}</span
									>
								</div>
							</div>
							<!--							<v-btn-->
							<!--								v-if="selectedRequest"-->
							<!--								elevation="0"-->
							<!--								class="rounded-pill"-->
							<!--								color="red darken-1"-->
							<!--								icon-->
							<!--								@click="deleteRequestTypeSelected(item, index)"-->
							<!--							>-->
							<!--								<v-icon>mdi-close-circle</v-icon>-->
							<!--							</v-btn>-->
						</div>
					</div>
				</v-row>
				<v-row v-if="getCurrentCreateProgress() === 'step-3'">
					<v-col v-if="selectedRequestGroup" cols="12">
						<div
							class="
								px-[12px]
								py-[16px]
								bg-mbf-color-6
								rounded
								flex flex-col
								gap-2
							"
						>
							<div class="flex">
								<div
									style="width: 100px"
									class="
										font-medium
										text-xs text-opacity-90 text-mbf-color-5
									"
								>
									Nhóm yêu cầu:
								</div>
								<div class="text-xs font-bold text-mbf-color-4">
									{{ selectedRequestGroup.requestGroupName }}
								</div>
							</div>
							<div class="flex">
								<div style="width: 100px">
									<span
										class="
											font-medium
											text-xs
											text-opacity-90
											text-mbf-color-5
										"
										>Loại yêu cầu:
									</span>
								</div>
								<div>
									<span
										class="
											text-xs
											text-opacity-90
											text-mbf-color-4
										"
									>
										{{ selectedRequest.requestName }}
									</span>
								</div>
							</div>
						</div>
					</v-col>
					<v-col cols="12">
						<div class="flex align-center">
							<div class="text-sm font-bold text-mbf-color-4">
								Thông tin Phiếu yêu cầu
							</div>
							&nbsp;
							<v-divider class="bg-mbf-color-3" />
						</div>
					</v-col>
					<v-col cols="12">
						<v-text-field
							maxLength="255"
							required
							filled
							hide-details
							:background-color="customColors['mbf-color-6']"
							v-model="m_requestDataDto.title"
						>
							<template v-slot:label>
								<span
									class="text-mbf-color-5 text-sm font-medium"
								>
									{{ $t("label.mail_template_subject") }}
								</span>
								<span class="text-red-600">
									{{ $t("label.star") }}
								</span>
							</template>
						</v-text-field>
					</v-col>
					<v-col
						cols="12"
						v-if="selectedRequest.enableCreatePYCFromOtherPYC"
					>
						<v-autocomplete
							v-if="selectedRequest.enableCreatePYCFromOtherPYC"
							v-model="
								requestDataIdFromPreviousPYC.requestDataCode
							"
							required
							ref="combobox"
							filled
							dense
							clearable
							hide-selected
							:items="requestDataCodes"
							item-text="requestDataCode"
							:background-color="customColors['mbf-color-6']"
							:item-value="(item) => item"
							@click="getAllRequestDataCodes('-1')"
							@keyup.enter="getAllRequestDataCodes"
						>
							<template v-slot:label>
								<span
									class="text-mbf-color-5 text-sm font-medium"
								>
									{{ $t("label.request_data_code_span") }}
								</span>
								<span class="text-red-600">{{
									$t("label.star")
								}}</span>
							</template>
							<template v-slot:item="{ item }">
								<v-list-item-content
									class="text-sm font-medium"
									style="max-width: 1000px"
								>
									{{ item.requestDataCode }}
								</v-list-item-content>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col cols="12">
						<tiptap-vuetify
							v-model="m_requestDataDto.description"
							:extensions="extensions"
							placeholder="Thông tin mô tả"
							min-height="100"
							:card-props="{
								outlined: true,
								color: '#FFFFFF',
							}"
							:toolbar-attributes="{
								color: customColors['mbf-color-6'],
							}"
							class="mb-4 mt-2 customize-tiptap"
						>
						</tiptap-vuetify>
					</v-col>
					<v-col cols="12">
						<v-select
							maxLength="255"
							filled
							v-model="selectedRequest.templateForms"
							:items="listAttachmentFileByRequestAll"
							:item-value="(item) => item"
							item-text="templateFormName"
							:background-color="customColors['mbf-color-6']"
							chips
							multiple
						>
							<template v-slot:label>
								<span
									class="text-mbf-color-5 text-sm font-medium"
								>
									{{ $t("label.application_form") }}
								</span>
							</template>
							<template v-slot:selection="{ attrs, item }">
								<v-chip
									v-bind="attrs"
									label
									close
									close-icon="mdi-close"
									color="#FFFFFF"
									@click:close="
										onRemoveItem(
											item,
											selectedRequest.templateForms,
										)
									"
								>
									<span class="text-xs text-mbf-color-4">{{
										item.templateFormName
									}}</span>
								</v-chip>
							</template>
						</v-select>
						<v-autocomplete
							maxLength="255"
							filled
							hide-details
							chips
							v-model="selectedRequest.processInfos"
							:items="listProcessInfos"
							:background-color="customColors['mbf-color-6']"
							return-object
							item-text="processName"
						>
							<template v-slot:label>
								<span
									class="text-mbf-color-5 text-sm font-medium"
								>
									{{ $t("label.application_process") }}
								</span>
								<span class="text-red-600">
									{{ $t("label.star") }}</span
								>
							</template>
							<template v-slot:selection="{ attrs, item }">
								<v-chip v-bind="attrs" label color="#FFFFFF">
									<span class="text-xs text-mbf-color-4">{{
										item.processName
									}}</span>
								</v-chip>
							</template>
						</v-autocomplete>
					</v-col>
					<v-col cols="12">
						<v-checkbox v-model="isRepeat" dense hide-details>
							<template v-slot:label>
								<span class="text-xs font-bold text-mbf-color-4"
									>Quy trình lặp</span
								>
							</template>
						</v-checkbox>
					</v-col>
					<v-col cols="12" v-if="isRepeat">
						<v-btn
							small
							:color="customColors['mbf-color-4']"
							dark
							@click="onEditProcessRepeat"
						>
							Thiết lập quy trình lặp
						</v-btn>
					</v-col>
				</v-row>
			</vue-perfect-scrollbar>
		</v-card-text>
		<v-card-actions
			class="mx-5 my-2"
			v-if="selectedRequest && selectedRequest.id"
		>
			<v-spacer></v-spacer>
			<v-btn
				:color="customColors['mbf-color-5']"
				@click="close"
				elevation="0"
				dark
			>
				<span class="text-xs">{{ $t("button.close") }}</span>
			</v-btn>
			<v-btn
				v-if="selectedRequest"
				:color="customColors['mbf-color-4']"
				dark
				elevation="0"
				@click="saveRequestData"
			>
				<span class="text-xs">{{ $t("button.ok") }}</span>
			</v-btn>
		</v-card-actions>
		<v-dialog v-model="dialog.isDialogWaning" width="60vw">
			<DialogWaning
				v-if="dialog.isDialogWaning"
				@close="dialog.isDialogWaning = false"
				:listData="
					requestDataIdFromPreviousPYC.requestDataCode
						.requsetDataContactIds
				"
			>
			</DialogWaning>
		</v-dialog>
	</v-card>
</template>

<script>
import RequestFormDataDto from "@/models/form-data.dto";
import ProcessDataDTO from "@/models/process-data.dto";
import RequestDataDto from "@/models/request-data.dto";
import StepDataDto from "@/models/step-data.dto";
import globalService from "@/services/global.service";
import administratorAPI from "@/views/modules/administrator/administrator.api";
import ReqDataProcessHisDto from "@/models/req-data-process-his.dto";
import ManageStampInfoDto from "@/models/manage-stamp-info.dto";
import SignDataDto from "@/models/sign-data.dto";
import DialogWaning from "@/views/modules/khai-phieu-yeu-cau/modulepopup/Selector/DialogWaning";
import EditProcessRepeat from "@/views/modules/administrator/ProcessRepeat/EditProcessRepeat";
import {
	// component
	TiptapVuetify,
	// extensions
	Heading,
	Bold,
	Italic,
	Strike,
	Underline,
	Code,
	Paragraph,
	BulletList,
	OrderedList,
	ListItem,
	Link,
	Blockquote,
	HardBreak,
	HorizontalRule,
	History,
	Image,
	Table,
	TableCell,
	TableHeader,
	TableRow,
} from "tiptap-vuetify";
import FieldData from "@/models/field-data.dto";
import GroupRequestIcon from "@/components/custom-icon/GroupRequestIcon";
import RequestIcon from "@/components/custom-icon/RequestIcon";

export default {
	name: "CreateRequestModule",
	components: {
		GroupRequestIcon,
		RequestIcon,
		TiptapVuetify,
		EditProcessRepeat,
		DialogWaning,
	},
	props: {},
	watch: {
		"requestDataIdFromPreviousPYC.requestDataCode"(val) {
			if (val?.requsetDataContactIds.length > 0) {
				this.dialog.isDialogWaning = true;
			}
		},
	},
	data() {
		return {
			isRepeat: false,
			dialog: {
				processRepeat: false,
				isDialogWaning: false,
			},
			processRepeat: null,
			noRequestResult: false,
			noResult: false,
			selectedRequestGroup: null,
			requestGroups: [],
			requestGroupsAll: [],
			requestGroupsDisplay: {},
			requestTypes: [],
			requestDataCodes: [],
			requestTypesAll: [],
			selectedRequest: null,
			listAttachmentFileByRequestAll: [],
			listStepInProcess: [],
			processData: null,
			listProcessInfos: [],
			listUserInfos: {},
			m_requestDataDto: Object.assign({}, RequestDataDto),
			search_request_group: "",
			search_request_type: "",
			listAttachmentFileRequest: [],
			extensions: [
				History,
				Table,
				TableCell,
				TableHeader,
				TableRow,
				Blockquote,
				Link,
				Underline,
				Strike,
				Italic,
				ListItem, // if you need to use a list (BulletList, OrderedList)
				BulletList,
				OrderedList,
				Image,
				[
					Heading,
					{
						// Options that fall into the tiptap's extension
						options: {
							levels: [1, 2, 3],
						},
					},
				],
				Bold,
				Link,
				Code,
				HorizontalRule,
				Paragraph,
				HardBreak, // line break on Shift + Ctrl + Enter
			],
			listRequest: [],
			fieldInForm: null,
			listRequestByGroupId: {},
			pageNum: 0,
			isLoading: false,
			firstLoad: true,
			requestDataIdFromPreviousPYC: {},
			titleDialog: null,
		};
	},

	async created() {
		await this.initialize();
	},
	destroyed() {
		this.deleteRequestTypeSelected();
		this.deleteRequestGroupSelected();
		this.listAttachmentFileByRequestAll = [];
		this.m_requestDataDto = Object.assign({}, RequestDataDto);
		this.listStepInProcess = [];
		this.processData = null;
		this.listProcessInfos = [];
		this.search_request_group = "";
		this.search_request_type = "";
		this.listAttachmentFileRequest = [];
		this.fieldInForm = null;
		this.getTitleDialog();
	},
	methods: {
		async initialize() {
			await this.getRequestGroups();
		},
		getTitleDialog() {
			if (this.selectedRequestGroup && !this.selectedRequest) {
				return this.$t("label.select_request_type");
			} else if (this.selectedRequest && this.selectedRequest.id) {
				return this.$t("title.create_request_data");
			} else {
				return this.$t("label.select_request_group");
			}
		},

		onEditProcessRepeat() {
			this.dialog.processRepeat = true;
		},

		async getAllRequestDataCodes(event) {
			let response;
			this.requestDataCodes = [];
			try {
				response = await globalService.getData_Async(
					administratorAPI.API_ShowAllRequestDataCodeFromCongTacPhi(
						event && event !== "-1" && event.target.value
							? event.target.value
							: "",
						0,
						100,
					),
				);
				if (!response) {
					return;
				}
				if (response.data && response.data.length) {
					this.requestDataCodes = response.data;
				}
			} catch (error) {
				this.toastError(error);
			}
		},

		async getRequestGroups() {
			let response;
			try {
				response = await globalService.getData_Async(
					administratorAPI.API_GetAllRequestGroupV2(),
				);
				if (!response || !response.state) {
					return [];
				}

				const result = response.data
					.filter((entry) => {
						return !entry.isDelete && entry.isActive;
					})
					.sort(function (a, b) {
						if (a?.requestGroupName < b?.requestGroupName) {
							return -1;
						}
						if (a?.requestGroupName > b?.requestGroupName) {
							return 1;
						}
						return 0;
					});
				this.requestGroups = [...result];
				this.requestGroupsAll = [...result];
			} catch (error) {
				console.error("getRequestGroups", error);
			}
		},

		clearForm() {
			this.deleteRequestTypeSelected();
			this.deleteRequestGroupSelected();

			this.listAttachmentFileByRequestAll = [];
			this.m_requestDataDto = Object.assign({}, RequestDataDto);
			this.listStepInProcess = [];
			this.processData = null;
			this.listProcessInfos = [];

			this.search_request_group = "";
			this.search_request_type = "";

			this.listAttachmentFileRequest = [];
			this.fieldInForm = null;
		},

		async getAttachmentFileRequest() {
			this.listAttachmentFileRequest = [];
			for (let templateForm of this.selectedRequest.templateForms) {
				let response;

				response = await globalService.getData_Async(
					administratorAPI.API_GetAllAttachmentFileByTemplateFormIdAndNotRequest(
						templateForm.id,
					),
				);
				if (!response || !response.state) {
					return [];
				}
				let listAttachmentTemplate = response.data.filter(
					(ele) => !ele.requestData,
				);
				this.listAttachmentFileRequest.push(...listAttachmentTemplate);
			}
		},

		prepareRequestDataPayload() {
			const regex = /(\+|-|=|@|\t|\r|\.|\/)/;
			if (regex.test(this.m_requestDataDto.title)) {
				this.toastError(
					"Tiêu đề tồn tại nhóm ký tự không phù hợp (+, -, =, @, ., /)",
				);
				return null;
			}
			if (!this.validRequiredText(this.m_requestDataDto.title)) {
				this.toastError(this.$t("message.empty_title"));
				return null;
			}
			if (this.m_requestDataDto.title?.length > 110) {
				this.toastError(
					this.$t("message.title_maxlength_required_110"),
				);
				return null;
			}

			if (!this.currentUserInfo?.id || !this.selectedRequest?.id) {
				return null;
			}

			let requestDataDTO = Object.assign({}, RequestDataDto);
			requestDataDTO.created = {
				id: this.currentUserInfo.id,
			};

			requestDataDTO.title = this.m_requestDataDto.title?.trim();
			requestDataDTO.description = this.m_requestDataDto.description
				? this.m_requestDataDto.description.trim()
				: "";
			requestDataDTO.modified = {
				id: this.currentUserInfo?.id,
			};

			const currentTime = new Date().toISOString();
			requestDataDTO.modifiedDate = currentTime;
			requestDataDTO.createdDate = currentTime;

			requestDataDTO.modifiedName = this.currentUserInfo?.fullName;
			requestDataDTO.processId = this.selectedRequest?.processInfos?.id;
			requestDataDTO.requestDataName = this.selectedRequest.requestName;
			requestDataDTO.request = { id: this.selectedRequest.id };
			requestDataDTO.created = this.currentUserInfo;
			requestDataDTO.createdName = this.currentUserInfo?.fullName;
			requestDataDTO.createdOrgName = this.currentUserInfo?.organizations
				?.map((ele) => ele.organizationName)
				?.join(", ");
			requestDataDTO.createdRankName = this.currentUserInfo?.ranks
				?.map((ele) => ele.rankName)
				?.join(", ");
			// lay api all status
			requestDataDTO.statusName = this.$t("label.drafting");
			requestDataDTO.status = { id: 1 };
			requestDataDTO.plotOfLandNumber = null;

			requestDataDTO.sapMapping = this.selectedRequest.sapMapping;
			requestDataDTO.formMapping = this.selectedRequest.formMapping;
			requestDataDTO.signTypeName = null;
			requestDataDTO.signTypeCode = 0;
			requestDataDTO.attachmentFileList = [];
			requestDataDTO.currentRound = 1;
			requestDataDTO.requestGroup = {
				id: this.selectedRequest.requestGroupId,
			};
			requestDataDTO.requestType = {
				id: this.selectedRequest.requestTypeId,
			};
			requestDataDTO.sapMapping = this.selectedRequest?.sapMapping;

			requestDataDTO.ruleGenerateAttachName =
				this.selectedRequest?.ruleGenerateAttachName;
			requestDataDTO.templateFormsId =
				this.selectedRequest?.templateForms?.map(
					(template) => template.id,
				) || [];

			return requestDataDTO;
		},

		async saveRequestData() {
			let response;
			if (this.isSaving) {
				return;
			}

			const requestDataPayload = this.prepareRequestDataPayload();
			try {
				if (!requestDataPayload) {
					return Promise.reject(
						Error("saveFormData() error in payload"),
					);
				}

				// CTP Công lệnh. Chả hiểu quang nó làm gì ở đây nhưng đại loại if else ở đây
				if (this.selectedRequest.enableCreatePYCFromOtherPYC) {
					if (!this.requestDataIdFromPreviousPYC) {
						return this.toastError(
							this.$t("message.empty_title_data_code"),
						);
					} else {
						requestDataPayload.requestDataCodeFromPreviousPYC =
							this.requestDataIdFromPreviousPYC.requestDataCode.requestDataCode?.split(
								"|",
							)[0];
						requestDataPayload.requestDataIdFromPreviousPYC =
							this.requestDataIdFromPreviousPYC.requestDataCode.id;

						response = await globalService.postData_Async(
							administratorAPI.API_CreatePYCFromOtherPYC(),
							requestDataPayload,
						);

						if (!response || !response.state) {
							this.toastError(this.$t("message.add_error"));

							return (this.isSaving = false);
						}

						this.requestData = response.data;
						await this.saveReqdataProcessHis();

						this.$emit("close", true);
						this.toastSuccess(this.$t("message.add_success"));
						this.clearForm();
						location.href = `/phieu-yeu-cau/${this.requestData?.id}/chi-tiet`;
						return;
					}
				}

				//Case chính tạo phiếu
				if (!this.selectedRequest.enableCreatePYCFromOtherPYC) {
					response = await globalService.postData_Async(
						administratorAPI.API_CreateRequestData(),
						requestDataPayload,
					);

					if (!response || !response.state) {
						this.toastError(this.$t("message.add_error"));

						return (this.isSaving = false);
					}

					this.requestData = response.data;

					// tầm này bó tay với đống bùi nhùi này r
					// note lại cho dễ hình dung phần nào thôi
					// FE tạo phiếu -> tạo requestData
					// để tạo hoàn chỉnh thì dùng id của requestData dựng nốt form, process, history,v..v

					// P/S: đã rework và đặt thêm log + abort khi fail rq gọi là đỡ khắm hơn thôi

					const procedures = [
						this.saveProcessData,
						this.getStepInProcesses,
						this.saveFormData,
						this.getFieldInForm,
						this.saveFieldData,
						this.saveStepData,
						this.saveReqdataProcessHis,
						this.createManageStampInfo,
						this.createSignData,
					];

					let isErrorWhileCreate = false;

					for (const procedure of procedures) {
						try {
							await procedure.call(this);
						} catch (error) {
							console.error(
								"Error saveRequestData() occurred:",
								error,
							);
							isErrorWhileCreate = true;
							break;
						}
					}

					if (isErrorWhileCreate) {
						//  abort by delete request
						await this.deleteRequest({ id: this.requestData.id });
						this.$emit("close", true);
						this.clearForm();
						return this.toastError(
							"Lỗi quá trình tạo phiếu, xin vui lòng tạo mới lại",
						);
					} else {
						this.$emit("close", true);
						this.toastSuccess(this.$t("message.add_success"));
						this.clearForm();
						location.href = `/phieu-yeu-cau/${this.requestData?.id}/chi-tiet`;
						return;
					}
				}
			} catch (error) {
				console.error("saveRequestData", error);
			}
		},

		async deleteRequest(payload) {
			try {
				let response = await globalService.postData_Async(
					administratorAPI.API_DeleteAllRequestData(),
					[payload],
				);
				if (!response?.state) {
					return;
				}
			} catch (e) {
				console.error("deleteRequest()", e);
			}
		},

		async getStepInProcesses() {
			const stepInProcessesId = this.selectedRequest?.processInfos?.id;
			try {
				if (!stepInProcessesId) {
					return Promise.reject(
						Error("getStepInProcesses() null payload"),
					);
				}
				let response = await globalService.getData_Async(
					administratorAPI.API_FindStepInProcessesByID(
						stepInProcessesId,
					),
				);
				if (!response.data) {
					return Promise.reject(
						Error("getStepInProcesses() failed request"),
					);
				}
				this.listStepInProcess = response.data.sort((a, b) => {
					return a.stepOrder - b.stepOrder;
				});
			} catch (error) {
				return Promise.reject(Error("getStepInProcesses()" + error));
			}
		},

		prepareProcessDataPayload() {
			if (
				!this.selectedRequest?.processInfos?.id ||
				!this.currentUserInfo?.id ||
				!this.requestData?.id
			)
				return null;

			let processDataDTO = Object.assign({}, ProcessDataDTO);
			processDataDTO.created = {
				id: this.currentUserInfo.id,
			};
			processDataDTO.createdDate = new Date().toISOString();
			processDataDTO.isActive =
				this.selectedRequest?.processInfos?.isActive;
			processDataDTO.isDelete =
				this.selectedRequest?.processInfos?.isDelete;
			processDataDTO.modified = {
				id: this.currentUserInfo.id,
			};
			processDataDTO.modifiedDate =
				this.selectedRequest?.processInfos?.modifiedDate;
			processDataDTO.modifiedName =
				this.selectedRequest?.processInfos?.modifiedName;
			processDataDTO.processDataCode =
				this.selectedRequest?.processInfos?.processCode;
			processDataDTO.processDataName =
				this.selectedRequest?.processInfos?.processName;
			processDataDTO.roundNumber = 1;
			processDataDTO.requestData = { id: this.requestData?.id };
			return processDataDTO;
		},

		async saveProcessData() {
			//process payload
			const processDataPayload = this.prepareProcessDataPayload();
			try {
				if (!processDataPayload) {
					return Promise.reject(
						Error("saveProcessData() null payload"),
					);
				}
				// Calling API endpoints
				let response = await globalService.postData_Async(
					administratorAPI.API_CreateProcessData(),
					processDataPayload,
				);

				if (!response?.data) {
					return Promise.reject(
						Error("saveProcessData() failed request"),
					);
				}
				this.processData = response.data;
			} catch (e) {
				return Promise.reject(Error("saveProcessData()" + e));
			}
		},

		prepareFormDataPayload() {
			if (
				!this.selectedRequest?.form?.id ||
				!this.currentUserInfo?.id ||
				!this.requestData?.id
			)
				return null;

			let requestFormDataDto = Object.assign({}, RequestFormDataDto);
			requestFormDataDto.option = this.selectedRequest.form.option;
			requestFormDataDto.formDataCode =
				this.selectedRequest.form?.formDataCode;
			requestFormDataDto.formDateName =
				this.selectedRequest.form?.formDateName;

			requestFormDataDto.objectModel = this.selectedRequest.form
				?.objectModel
				? this.selectedRequest.form.objectModel
				: "{}";
			requestFormDataDto.createdName =
				this.selectedRequest.form?.createdName;
			requestFormDataDto.createdDate = new Date();
			requestFormDataDto.modifiedName =
				this.selectedRequest.form.modifiedName;
			requestFormDataDto.modifiedDate =
				this.selectedRequest.form.modifiedDate;
			requestFormDataDto.isActive = this.selectedRequest.form?.isActive;
			requestFormDataDto.isDelete = this.selectedRequest.form?.isDelete;
			requestFormDataDto.created = {
				id: this.currentUserInfo?.id,
			};
			requestFormDataDto.modified = {
				id: this.currentUserInfo?.id,
			};

			requestFormDataDto.requestData = {
				id: this.requestData?.id,
			};
			requestFormDataDto.form = { id: this.selectedRequest.form.id };

			return requestFormDataDto;
		},

		async saveFormData() {
			const formDataPayload = this.prepareFormDataPayload();
			try {
				if (!formDataPayload) {
					return Promise.reject(Error("saveFormData() null payload"));
				}

				let response = await globalService.postData_Async(
					administratorAPI.API_CreateFormData(),
					formDataPayload,
				);
				if (!response?.state) {
					return Promise.reject(
						Error("saveFormData() failed request"),
					);
				}
			} catch (e) {
				return Promise.reject(Error("saveFormData()" + e));
			}
		},

		prepareStepDataPayload() {
			let payloadStepDatas = [];
			if (
				!this.listStepInProcess ||
				!this.currentUserInfo?.id ||
				!this.requestData?.id ||
				!this.processData?.id
			)
				return null;

			for (let stepInProcess of this.listStepInProcess) {
				let payloadStepDataDTO = Object.assign({}, StepDataDto);

				// thay code cũ đi mapping thủ công rất nông dân ( tiên sư 2bsystem )
				// code mới sẽ là semi-mapping, những trường mapping thủ công phía dưới
				// phần lớn là trường cần map khóa chính, ít cập nhật
				// các flag cấu hình phụ thuộc bên object step-data-dto định nghĩa bổ sung thêm
				// ko cần map thủ công như trước đây

				// auto merge
				payloadStepDataDTO = this.mergeObjectsWithSameKey(
					payloadStepDataDTO,
					stepInProcess,
				);

				//manual merge
				payloadStepDataDTO.id = null;
				payloadStepDataDTO.isActive = false;
				payloadStepDataDTO.roundNumber = 1;

				const currentTime = new Date().toISOString();
				payloadStepDataDTO.createdDate = currentTime;
				payloadStepDataDTO.modifiedDate = currentTime;
				payloadStepDataDTO.timeActive = currentTime;

				payloadStepDataDTO.created = { id: this.currentUserInfo.id };
				payloadStepDataDTO.modified = {
					id: this.currentUserInfo.id,
				};
				payloadStepDataDTO.createdOrgName =
					this.currentUserInfo?.organizations
						?.map((ele) => ele.organizationName)
						?.join(", ");
				payloadStepDataDTO.createdRankName = this.currentUserInfo?.ranks
					?.map((ele) => ele.rankName)
					?.join(", ");

				payloadStepDataDTO.step = { id: stepInProcess.step?.id };
				payloadStepDataDTO.processData = {
					id: this.processData?.id,
				};
				payloadStepDataDTO.requestData = {
					id: this.requestData?.id,
				};
				payloadStepDataDTO.stepInProcess = { id: stepInProcess.id };
				payloadStepDataDTO.stepDataCode =
					stepInProcess.stepInProcessCode;
				payloadStepDataDTO.stepDataName =
					stepInProcess.stepInProcessName;

				payloadStepDataDTO.organizationCode =
					stepInProcess.organization?.organizationCode;
				payloadStepDataDTO.organizationName =
					stepInProcess.organization?.organizationName;
				payloadStepDataDTO.mailTemplateCustomer =
					stepInProcess?.mailTemplateCustomer
						? { id: stepInProcess.mailTemplateCustomer?.id }
						: null;
				payloadStepDataDTO.mailTemplateCTP =
					stepInProcess?.mailTemplateCTP
						? { id: stepInProcess.mailTemplateCTP?.id }
						: null;
				payloadStepDataDTO.userInfos = stepInProcess.userInStepDTOs.map(
					(entry) => {
						return { id: entry.userInfo.id };
					},
				);
				payloadStepDataDTO.userInfosMailTemplateCTP =
					stepInProcess.userShareInStepDTOs.map((entry) => {
						return { id: entry.userInfo.id };
					});

				payloadStepDatas.push(payloadStepDataDTO);
			}
			return payloadStepDatas;
		},

		async saveStepData() {
			let payloadStepDatas = this.prepareStepDataPayload();
			try {
				if (!payloadStepDatas) {
					return Promise.reject(Error("saveStepData() null payload"));
				}
				let response = await globalService.postData_Async(
					administratorAPI.API_OverwriteStepData(),
					payloadStepDatas,
				);
				if (!response) {
					return Promise.reject(
						Error("saveStepData() failed request"),
					);
				}
			} catch (error) {
				return Promise.reject(Error("saveStepData()" + error));
			}
		},

		onSaveProcessRepeat(value) {
			this.processRepeat = value;
			this.m_requestDataDto.title = value.titlePYC;
			this.m_requestDataDto.description = value.description;
		},
		close() {
			this.clearForm();
			this.$emit("close", true);
		},

		prepareRequestProcessHistoryPayload() {
			if (!this.requestData?.id || !this.currentUserInfo?.id) return null;

			const requestProcessHis = Object.assign({}, ReqDataProcessHisDto);
			requestProcessHis.createDate = new Date();
			requestProcessHis.description = this.$t("label.editor");
			requestProcessHis.organizationName = null;
			requestProcessHis.processDate = new Date();
			requestProcessHis.processer = this.currentUserInfo;
			requestProcessHis.processerName = this.currentUserInfo.fullName;
			requestProcessHis.rankName = null;
			requestProcessHis.requestData = {
				id: this.requestData?.id,
			};
			requestProcessHis.status = this.$t("label.drafting");

			requestProcessHis.isChild = false;
			requestProcessHis.stepData = null;
			return requestProcessHis;
		},

		async saveReqdataProcessHis() {
			const requestPayload = this.prepareRequestProcessHistoryPayload();
			try {
				if (!requestPayload) {
					return Promise.reject(
						Error("saveReqdataProcessHis() null payload"),
					);
				}

				let response = await globalService.postData_Async(
					administratorAPI.API_CreateReqdataProcessHis(),
					requestPayload,
				);
				if (!response?.state) {
					return Promise.reject(
						Error("saveReqdataProcessHis() failed request"),
					);
				}
			} catch (error) {
				return Promise.reject(Error("saveReqdataProcessHis()" + error));
			}
		},

		async selectRequestGroup(item) {
			this.selectedRequestGroup = item;

			if (this.listRequestByGroupId[item.id]?.length > 0) {
				this.requestTypes = [...this.listRequestByGroupId[item.id]];
				this.requestTypesAll = [...this.listRequestByGroupId[item.id]];
			} else {
				let response = await globalService.getData_Async(
					administratorAPI.API_GetRequestByRequestGroupIdV3(
						item.id,
						this.currentUserInfo?.organizations[0].id,
					),
				);
				if (!response || !response.state) return;
				let result = response.data
					.filter((el) => !el.isDelete)
					.sort((a, b) =>
						(a?.requestName || "").localeCompare(
							b?.requestName || "",
						),
					);
				this.listRequestByGroupId[item.id] = [...result];
				this.requestTypes = [...result];
				this.requestTypesAll = [...result];
			}
		},
		async getTemplateByRequestId(requestId) {
			try {
				let response = await globalService.getData_Async(
					administratorAPI.API_GetTemplateByRequestId(requestId),
				);
				if (!response || !response.state) {
					return [];
				}
				return response.data;
			} catch (e) {
				console.error("getTemplateByRequestId", e);
			}
		},
		async getFormByRequestId(requestId) {
			try {
				let response = await globalService.getData_Async(
					administratorAPI.API_GetFormByRequestId(requestId),
				);
				if (!response || !response.state) {
					return null;
				}
				return response.data[0];
			} catch (e) {
				console.error("getFormByRequestId", e);
			}
		},
		async getAllProcessInfosByRequestId(requestId) {
			try {
				let response = await globalService.getData_Async(
					administratorAPI.GetAllProcessInfosByRequestId_v2(
						requestId,
					),
				);
				if (!response) {
					return [];
				}
				return response;
			} catch (e) {
				console.error("getAllProcessInfosByRequestId", e);
			}
		},
		async selectRequestType(item) {
			if (this.selectedRequest) {
				return;
			}
			this.isSaving = false;
			this.selectedRequest = item;

			const [_templateForms, _form, _processInfos] = await Promise.all([
				this.getTemplateByRequestId(this.selectedRequest.id),
				this.getFormByRequestId(this.selectedRequest.id),
				this.getAllProcessInfosByRequestId(this.selectedRequest.id),
			]);

			if (_templateForms?.length > 0) {
				this.selectedRequest.templateForms = [..._templateForms];
				this.listAttachmentFileByRequestAll = [
					...this.selectedRequest.templateForms,
				];
			}
			this.selectedRequest.form = _form;

			if (_processInfos?.length > 0) {
				this.selectedRequest.processInfos = _processInfos[0];
				this.listProcessInfos = [..._processInfos];
			} else {
				this.toastError(
					this.$t(
						"message.this_request_type_is_not_fully_configured",
					),
				);
				this.isSaving = true;
			}
		},

		deleteRequestGroupSelected() {
			this.selectedRequestGroup = null;
			this.selectedRequest = null;
		},
		deleteRequestTypeSelected() {
			this.selectedRequest = null;
		},
		onRollbackSelection() {
			this.search_request_type = "";
			this.noRequestResult = false;
			if (this.selectedRequestGroup) {
				if (this.selectedRequest) {
					this.selectedRequest = null;
				} else {
					this.selectedRequestGroup = null;
				}
			}
		},

		prepareStampInfoPayload() {
			if (!this.requestData?.id) return null;
			let manageStampInfoDto = Object.assign({}, ManageStampInfoDto);
			manageStampInfoDto.requestData = { id: this.requestData?.id };
			return manageStampInfoDto;
		},

		async createManageStampInfo() {
			const requestPayload = this.prepareStampInfoPayload();
			try {
				if (!requestPayload) {
					return Promise.reject(
						Error("createManageStampInfo() null payload"),
					);
				}
				const response = await globalService.postData_Async(
					administratorAPI.API_createManageStampInfo(),
					requestPayload,
				);
				if (!response?.state) {
					return Promise.reject(
						Error("createManageStampInfo() failed request"),
					);
				}
			} catch (error) {
				return Promise.reject(Error("createManageStampInfo()" + error));
			}
		},

		prepareSignDataPayload() {
			if (!this.requestData?.id) return null;
			let signDataDto = Object.assign({}, SignDataDto);
			signDataDto.requestData = { id: this.requestData?.id };
			return signDataDto;
		},

		async createSignData() {
			let signDataPayload = this.prepareSignDataPayload();
			try {
				if (!signDataPayload) {
					return Promise.reject(
						Error("createSignData() null payload"),
					);
				}
				let response = await globalService.postData_Async(
					administratorAPI.API_createSignData(),
					signDataPayload,
				);
				if (!response?.state) {
					return Promise.reject(
						Error("createSignData() failed request"),
					);
				}
			} catch (error) {
				return Promise.reject(Error("createSignData()" + error));
			}
		},

		findRequestGroup() {
			this.noResult = false;
			if (this.search_request_group.length > 0) {
				// this.search_request_group = this.search_request_group.trim();
				this.requestGroups = this.requestGroupsAll.filter((entry) => {
					return this.nonAccentVietnamese(entry.requestGroupName)
						.toLocaleUpperCase()
						.includes(
							this.nonAccentVietnamese(this.search_request_group)
								.trim()
								.toLocaleUpperCase(),
						);
				});
				if (this.requestGroups.length == 0) {
					this.noResult = true;
				}
			} else {
				this.requestGroups = this.requestGroupsAll.sort(function (
					a,
					b,
				) {
					// moment(b?.modifiedDate).toDate().getTime() -
					// moment(a?.modifiedDate).toDate().getTime()
					if (a?.requestGroupName < b?.requestGroupName) {
						return -1;
					}
					if (a?.requestGroupName > b?.requestGroupName) {
						return 1;
					}
					return 0;
				});
				this.noResult = false;
			}
		},
		findRequestType() {
			this.noRequestResult = false;

			if (this.search_request_type.length > 0) {
				this.requestTypes = this.requestTypesAll.filter((entry) => {
					return this.nonAccentVietnamese(entry.requestName)
						.toLocaleUpperCase()
						.includes(
							this.nonAccentVietnamese(this.search_request_type)
								.trim()
								.toLocaleUpperCase(),
						);
				});
				if (this.requestTypes.length == 0) {
					this.noRequestResult = true;
				}
			} else {
				this.requestTypes = this.requestTypesAll.sort(function (a, b) {
					// moment(b?.modifiedDate).toDate().getTime() -
					// moment(a?.modifiedDate).toDate().getTime()
					if (a?.requestName < b?.requestName) {
						return -1;
					}
					if (a?.requestName > b?.requestName) {
						return 1;
					}
					return 0;
				});
				this.noRequestResult = false;
			}
		},

		async getFieldInForm() {
			const id = this.selectedRequest?.form?.id;
			try {
				if (!id) {
					return Promise.reject(Error("getFieldInForm() null param"));
				}
				let response = await globalService.getData_Async(
					administratorAPI.API_FindFieldInForm(id),
				);
				if (!response?.data) {
					return Promise.reject(
						Error("getFieldInForm() failed request"),
					);
				}
				if (response.data.length > 0) {
					this.fieldInForm = response.data.sort(
						(e2, e1) => e2.order - e1.order,
					);
				}
			} catch (error) {
				return Promise.reject(Error("getFieldInForm()" + error));
			}
		},

		onRemoveItem(item, arr) {
			arr.splice(arr.indexOf(item), 1);
		},

		getCurrentCreateProgress() {
			if (!this.selectedRequestGroup && !this.selectedRequest) {
				return "step-1";
			} else if (this.selectedRequestGroup && !this.selectedRequest) {
				return "step-2";
			} else if (this.selectedRequestGroup && this.selectedRequest) {
				return "step-3";
			}
		},

		prepareFieldDataPayload() {
			let fieldDataAll = [];
			if (
				!this.fieldInForm?.length ||
				!this.currentUserInfo?.id ||
				!this.requestData?.id
			)
				return null;

			for (const field of this.fieldInForm) {
				let fieldData = Object.assign({}, FieldData);

				fieldData.created = { id: this.currentUserInfo.id };
				fieldData.createdDate = new Date();
				fieldData.modified = null;
				fieldData.modifiedDate = new Date();
				fieldData.order = field.order;
				fieldData.objectSchema = field.objectSchema;
				fieldData.nameOfField = field.nameOfField;
				fieldData.row = field.row;
				fieldData.col = field.col;
				fieldData.option = field.option;
				fieldData.description = field.description;
				fieldData.requestData = { id: this.requestData?.id };
				fieldData.fieldDataName = field.fieldInFormName;
				fieldData.fieldDataCode = field.fieldInFormCode;
				fieldData.tenantCode = JSON.parse(field.objectSchema).title
					.Headers
					? "truong_bang"
					: JSON.parse(field.objectSchema).title.upload_ext
					? "truong_file"
					: JSON.parse(field.objectSchema).title.type == "number" &&
					  !JSON.parse(field.objectSchema).title.double
					? "number"
					: JSON.parse(field.objectSchema).title.type == "number" &&
					  JSON.parse(field.objectSchema).title.double
					? "double"
					: "";
				fieldDataAll.push(fieldData);
			}
			return fieldDataAll;
		},

		async saveFieldData() {
			let fieldDataPayload = this.prepareFieldDataPayload();
			try {
				if (!fieldDataPayload) {
					return Promise.reject(
						Error("saveFieldData() null payload"),
					);
				}
				let response = await globalService.postData_Async(
					administratorAPI.API_CreateAllFieldDataByRequestDataIdV2(
						true,
					),
					fieldDataPayload,
				);

				if (!response || !response.state) {
					return Promise.reject(
						Error("saveFieldData() failed request"),
					);
				}
			} catch (e) {
				return Promise.reject(Error("saveFieldData()" + e));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.v-menu__content {
	min-width: 1094px !important;
}
.v-combobox v-list-item-content {
	max-height: 10px; /* or any value you prefer */
	overflow: hidden;
	max-width: 1094px;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.v-list-item__content {
	max-width: 1040px;
}
.requestGroupHover:hover {
	background: linear-gradient(
		90deg,
		rgba(246, 161, 72, 0.09) 0%,
		rgba(246, 161, 72, 0.009) 92.43%
	);

	box-shadow: 3px 3px 20px 3px rgba(0, 97, 175, 0.06);

	border-radius: 10px;
}
.requestTypeHover:hover {
	background: linear-gradient(
		90deg,
		rgba(0, 109, 238, 0.09) 0%,
		rgba(0, 109, 238, 0.009) 92.43%
	) !important;
	border-radius: 10px;
	box-shadow: 3px 3px 20px 3px rgba(0, 97, 175, 0.06);
}
.requestGroupHover:hover .iconNhomYc {
	background: none !important;
}
.requestTypeHover:hover .iconLoaiYc {
	background: none !important;
}
.iconNhomYc {
	display: flex;
	justify-content: center;
	align-content: center;
	height: 48px;
	width: 48px;
	padding: 12px;
	background: linear-gradient(
		90deg,
		rgba(246, 161, 72, 0.09) 0%,
		rgba(246, 161, 72, 0.009) 92.43%
	);
}
.iconLoaiYc {
	display: flex;
	justify-content: center;
	align-content: center;
	height: 48px;
	width: 48px;
	padding: 12px;
	background: linear-gradient(
		90deg,
		rgba(0, 109, 238, 0.09) 0%,
		rgba(0, 109, 238, 0.009) 92.43%
	);
}

::v-deep .customize-tiptap .tiptap-vuetify-editor__content {
	//border: thin solid #0061AF;
	border-radius: 4px !important;
	margin-top: 10px;
	background-color: #f7f9fe;
}
</style>
